/**
 * Intent APIs
 */

import { AxiosResponse } from "axios";
import { Endpoint } from "./util/contants";
import { IntentDataModel } from "./responsePayload/IntentResponse";
import { PaginationResponse } from "./responsePayload/PaginationResponse";
import {
  apiDeleteRequest,
  apiGetRequest,
  apiPatchRequest,
  apiPostRequest,
  createPayload,
} from "./util/apiUtils";

export const GetIntents = async (
  endpoint: string | undefined = Endpoint.Intent,
  page: number | undefined = undefined,
  pageSize: number | undefined = undefined,
  queryParams: Record<string, any> = {}
): Promise<PaginationResponse<IntentDataModel> | undefined> => {
  const path = {
    id: undefined,
  };

  const query = {
    ...queryParams,
    page: page,
    page_size: pageSize,
  };

  return await apiGetRequest<PaginationResponse<IntentDataModel>>(
    endpoint,
    path,
    query
  );
};

export const GetIntentId = async (
  id: number | undefined = undefined
): Promise<IntentDataModel | undefined> => {
  try {
    return await apiGetRequest<IntentDataModel>(Endpoint.Intent, {
      id: id,
    });
  } catch {
    return undefined;
  }
};

export const DeleteIntentKnowledge = async (
  id: number
): Promise<AxiosResponse | null> => {
  return await apiDeleteRequest(Endpoint.Intent, {
    id: id,
  });
};

export const AddIntentKnowledge = async (
  detailInput: string,
  rawInput: string,
  categoryId: number,
  meaning: string
): Promise<AxiosResponse | null> => {
  const basePayload = {
    raw_input: rawInput,
    detailed_input: detailInput,
    category: categoryId,
    meaning: meaning,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.IntentPost, payload);
};

export const EditIntentKnowledge = async (
  id: number,
  detailInput: string,
  rawInput: string,
  categoryId: number,
  meaning?: string
): Promise<IntentDataModel | null> => {
  const basePayload = {
    raw_input: rawInput,
    detailed_input: detailInput,
    category: categoryId,
    ...(meaning && { meaning: meaning }),
  };
  const payload = createPayload(basePayload);
  const response = await apiPatchRequest(Endpoint.Intent, { id: id }, payload);

  return response as IntentDataModel | null;
};
